import WhatsAppEventModal from './WhatsAppEventModal';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
  onTramiteUpdated?: () => Promise<void> | void;
};

const WhatsAppEscrituraModal = ({ open, onOpenChange, tramite, onTramiteUpdated }: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      onTramiteUpdated={onTramiteUpdated}
      eventType="escrituras.envio_escritura"
      title="Enviar escritura por WhatsApp"
      description="Se enviará la escritura con enlace temporal seguro."
    />
  );
};

export default WhatsAppEscrituraModal;
